import { Entity, Field } from "typegraph";

@Entity({one: "organization", many: "organizations"})
class ChildOrganization {

	@Field()
	public id: string;

	@Field()
	public name: string;

	@Field()
	public guid: string;

}

// tslint:disable-next-line:max-classes-per-file
@Entity({one: "organization", many: "organizations"})
export default class Organization {

	@Field()
	public id: string;

	@Field()
	public name: string;

	@Field()
	public guid: string;

	@Field()
	public logoURL: string;

	@Field({entity: ChildOrganization})
	public children: ChildOrganization[];

}



// WEBPACK FOOTER //
// ./src/panels/organizations/admin/summary/entities/Organization.ts